<script setup lang="ts">
import ErrorBoundary from "@/components/ErrorBoundary/index.vue";
import OpenningPage from "@/views/OpenningPage/index.vue";
import getRoutes from "@/router/initRoutes";
import {
  useSystemInfo,
  useActivityList,
  useGameCategory,
  useHomeBannersAndTexts,
  useOpenningImage,
  useWallet,
  useServico,
} from "@/store";
import useAPP from "@/hooks/useInstall";
import { ev, CUSTOM_PROTOCOL } from "@/consts";
import { wait } from "@/utils";
import { usePWAJumpIframe } from "@/hooks/usePWAJumpIframe";
const { isPWA, iframeUrl, shouldShowIframe } = usePWAJumpIframe();
const isLoading = ref(true);

const loadingToast = showLoadingToast({
  message: "loading...",
  forbidClick: true,
  duration: 0,
});

const router = useRouter();
const route = useRoute();

const init = async () => {
  if (route.query.s === "1") return;

  // await useSystemInfo().init();
  useAPP().init();

  const initRoutes = async () => {
    const theme = useSystemInfo().theme;
    document.body.dataset.theme = theme;

    const routes = await getRoutes(theme);
    routes.forEach(router.addRoute);
  };

  const initData = () => {
    return Promise.all(
      [
        useOpenningImage(),
        useActivityList(),
        useGameCategory(),
        useHomeBannersAndTexts(),
        useServico(),
        useWallet(),
      ].map((store) => store.init())
    );
  };

  ev.on("login", () => {
    initData();
  });

  ev.on("logout", () => {
    initData();
  });

  await Promise.all([initRoutes(), initData(), wait(2)]);
};

const handlePwaRedirect = () => {
  return "/" + route.query.pwaredirect!.toString().replace(CUSTOM_PROTOCOL + "://", "");
};

const showPage = async () => {
  router.removeRoute("openning");
  const isPwaDirect = !!route.query.pwaredirect;
  const url = isPwaDirect ? handlePwaRedirect() : location.pathname + location.search;
  await router.replace(url);

  isLoading.value = false;
  loadingToast.close();
};

init()
  .then(showPage)
  .catch((error) => {
    console.error(error);
    showFailToast({
      iconSize: 30,
      message: "Failed to init, please try later",
      duration: 0,
      wordBreak: "break-word",
    });
  });

// const route = useRoute();
// const cachedRoutes = ref<string[]>([]);
// watch(route, (newRoute) => {
//   if (newRoute.meta.keepAlive) {
//     if (!cachedRoutes.value.includes(newRoute.name as string)) {
//       cachedRoutes.value.push(newRoute.name as string);
//     }
//   }
// });
</script>

<template>
  <iframe v-if="shouldShowIframe && isPWA" class="w-full h-full" :src="iframeUrl" />
  <template v-else>
    <OpenningPage v-if="isLoading" />
    <router-view v-slot="{ Component }">
      <ErrorBoundary>
        <!-- <keep-alive :include="cachedRoutes"> -->
        <component :is="Component" />
        <!-- </keep-alive> -->
      </ErrorBoundary>
    </router-view>
  </template>
</template>
